import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
const containerCss = "cg699og";

/**
 * Empty feed state when a meetings page preset is active but the preset query returned no meetings.
 */
export const PresetEmptyMeetings = () => <div className={containerCss} data-testid="preset-empty-meetings">
    <BodyText color="muted">
      {I18n.t('publisher.meetings.preset_tabs.no_meetings_this_date')}
    </BodyText>
  </div>;

require("./preset_empty_meetings.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./preset_empty_meetings.js");